import React from 'react';
import { SvgIcon } from '../svg-icon';

export const ArrowRight3 = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M3.5 11.5H15.67L10.08 5.91L11.5 4.5L19.5 12.5L11.5 20.5L10.09 19.09L15.67 13.5H3.5V11.5Z" />
  </SvgIcon>
);
